import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Box,
  Grid,
  Stack,
  Button,
  Checkbox,
  TextField,
  IconButton,
  Typography,
  DialogActions,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
//date picker
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//Import from project
import {
  SelectSchools,
  SelectProgramme,
  SelectAcademicYear,
  SelectCustomerByStudent,
  SelectStudentByAcademic,
  SelectStudentEnrollmentForInvoice,
} from "../../Include/DynamicSelect";
import "../../../Style/dialogstyle.scss";
import EnrollmentTabs from "./EnrollmentTabs";
import { BiMinusCircle } from "react-icons/bi";
import { AuthContext } from "../../../Context/AuthContext";
import PrintInvoiceForCreate from "./PrintInvoiceForCreate";
import { translateLauguage } from "../../../Function/Translate";
import { CREATE_INVOICE_FOR_STUDENT, GET_NEXT_INVOICE_ID, GET_SERVICE_TOPAY_NOTIFICATION_BY_STUDENT, UPDATE_MANY_SERVICE_TOPAY_NOTIFICATION_NOT_SHOW, GET_LAST_EXCHANGE_RATE } from "../../../Schema/Invoice";

export default function CreateReceipt({ open, handleClose, setRefetch }) {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);
  const [required, setRequired] = useState(false);

  const [value, setValue] = useState(0);
  const [programmVal, setProgrammVal] = useState({ id: "", title: "" });
  const [checkedAdditionalFee, setCheckedAdditionalFee] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState({ id: "", title: "", });
  const [selectedCustomer, setSelectedCustomer] = useState({ id: "", title: "" });
  const [selectedStudent, setSelectedStudent] = useState({ id: "", title: "", data: null });
  const [classVal, setClassVal] = useState({ id: "", title: "", classId: "", enrollmentId: "", gradeId: "" });
  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "", endDate: null, startDate: null });
  const [serviceToPayData, setServiceToPayData] = useState([])
  const [lastExchangeRate, setLastExchangeRate] = useState(0)

  //Modal update
  const [openPrint, setOpenPrint] = useState(false);
  const handleOpenPrint = () => setOpenPrint(true);
  const handleClosePrint = () => setOpenPrint(false);

  const [listPaymentData, setListPaymentData] = useState([]);

  const paymentItem = {
    discount: 0,
    countMonth: 1,
    endDate: null,
    startDate: null,
    incomeHead: null,
    unit: null,
    key: Date.now() + Math.random(),
  }

  // console.log("academicYearVal?.id::", academicYearVal?.id, selectedStudent?.id)

  // getLatestExchangeRate ======================================================================
  const { refetch: retchExchangeRate } = useQuery(GET_LAST_EXCHANGE_RATE, {
    onCompleted: ({ getLatestExchangeRate }) => {
      // console.log("getLatestExchangeRate::", getLatestExchangeRate)
      setLastExchangeRate(getLatestExchangeRate)
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    retchExchangeRate()
  }, [open])

  // getServiceToPayNotificationByStudent =======================================================
  const { refetch } = useQuery(GET_SERVICE_TOPAY_NOTIFICATION_BY_STUDENT, {
    variables: {
      studentId: selectedStudent?.id || null,
      academicYearId: academicYearVal?.id || null,
    },
    onCompleted: ({ getServiceToPayNotificationByStudent }) => {
      // console.log("getServiceToPayNotificationByStudent::", getServiceToPayNotificationByStudent)
      if (getServiceToPayNotificationByStudent?.length > 0) {
        const prepareData = getServiceToPayNotificationByStudent?.map((row) => {
          return {
            _id: row?._id,
            className: row?.className,
            dateToBePaid: row?.dateToBePaid,
            englishName: row?.englishName,
            estimateAmount: row?.estimateAmount,
            verifiedAmount: row?.verifiedAmount,
            firstName: row?.firstName,
            gradeName: row?.gradeName,
            incomeHeadName: row?.incomeHeadName,
            incomeType: row?.incomeType,
            isShowMobileApp: row?.isShowMobileApp,
            lastName: row?.lastName,
            studentId: row?.studentId,
            status: false,
          }
        })
        setServiceToPayData(prepareData)
      } else {
        setServiceToPayData([])
      }
    },
    onError: ({ message }) => {
      setServiceToPayData([])
      console.log("Error::", message);
    },
  });

  const [updateManyServiceToPayNotificationNotShowOnMonile] = useMutation(UPDATE_MANY_SERVICE_TOPAY_NOTIFICATION_NOT_SHOW, {
    onCompleted: ({ updateManyServiceToPayNotificationNotShowOnMonile }) => {
      // console.log("updateManyServiceToPayNotificationNotShowOnMonile :", updateManyServiceToPayNotificationNotShowOnMonile)
      // setLoading(false);
      if (updateManyServiceToPayNotificationNotShowOnMonile?.status === true) {
        setAlert(true, "success", updateManyServiceToPayNotificationNotShowOnMonile?.message);
      } else {
        setAlert(true, "error", updateManyServiceToPayNotificationNotShowOnMonile?.message);
      }
    },
    onError: ({ message }) => {
      // setLoading(false);
      setAlert(true, "error", message);
    },
  });

  useEffect(() => {
    refetch()
  }, [academicYearVal?.id, selectedStudent?.id])

  const handleCheckServiceToPay = (id, status) => {
    let newData = serviceToPayData
    // console.log("newData::", newData)
    newData?.map((data) => {
      if (data?._id === id) {
        data.status = status
      }
    })
    // console.log("newData::", newData)
    setServiceToPayData(newData)
  }

  const handleUpdateServiceToPayNotification = () => {
    let submitData = serviceToPayData?.filter((data) => data?.status === true).map((data) => {
      return data?._id
    })
    // console.log("newData::", newData)
    // setServiceToPayData(newData)
    updateManyServiceToPayNotificationNotShowOnMonile({
      variables: {
        id: submitData,
      }
    })
  }

  // getServiceToPayNotificationByStudent =======================================================

  const [createInvoiceForStudent] = useMutation(CREATE_INVOICE_FOR_STUDENT, {
    onCompleted: ({ createInvoiceForStudent }) => {
      // console.log("createInvoiceForStudent :", createInvoiceForStudent)
      setLoading(false);
      if (createInvoiceForStudent?.status === true) {
        setAlert(true, "success", createInvoiceForStudent?.message);
        handleClose();
        resetForm();
        setRefetch();
        setValue(0);
        setCheckedAdditionalFee(false);
      } else {
        setAlert(true, "error", createInvoiceForStudent?.message);
      }
    },
    onError: ({ message }) => {
      console.log("error : ", message)
      setLoading(false);
    },
  });

  let exchangeRateLocal = parseFloat(JSON.parse(window.localStorage.getItem("sms-invoice-exchange-rate")));
  // let exchangeRateLocal = parseFloat(localStorage.getItem("sms-invoice-exchange-rate"));
  // console.log('exchangeRateLocal::', exchangeRateLocal)
  let createdAtLocal = moment() > localStorage.getItem("sms-invoice-created-at") ? moment() : localStorage.getItem("sms-invoice-created-at");

  //fromik
  const Validate = Yup.object().shape({
    month: Yup.string(),
    Amount: Yup.string(),
    quarter: Yup.string(),
    discount: Yup.string(),
    netAmount: Yup.string(),
    grossAmount: Yup.string(),
    groupFeeType: Yup.string(),
    manualDiscount: Yup.string(),
    academicTermId: Yup.string(),
    discountAmount: Yup.string(),
    billTo: Yup.string().required("required!"),
    classId: Yup.string().required("required!"),
    schoolId: Yup.string().required("required!"),
    studentId: Yup.string().required("required!"),
    programId: Yup.string().required("required!"),
    paymentDate: Yup.string().required("required!"),
    exchangeRate: Yup.number().required("required!"),
    academicYearId: Yup.string().required("required!"),
  });

  const formik = useFormik({
    initialValues: {
      month: "",
      Amount: "",
      billTo: "",
      classId: "",
      quarter: "",
      discount: "",
      schoolId: "",
      netAmount: "",
      studentId: "",
      programId: "",
      grossAmount: "",
      groupFeeType: "",
      academicTermId: "",
      academicYearId: "",
      manualDiscount: "",
      discountAmount: "",
      // paymentDate: createdAtLocal !== undefined && createdAtLocal !== null && createdAtLocal !== "" ? createdAtLocal : moment(),
      paymentDate: moment(),
      exchangeRate: lastExchangeRate,
    },
    validationSchema: Validate,
    onSubmit: async (values) => {

      if (listPaymentData.length === 0 && checkedAdditionalFee) {
        setListPaymentData([paymentItem]);
        return;
      }

      const checkError = [];
      listPaymentData?.map((e) => {
        if (!e?.countMonth || !e?.incomeHead?.id 
          // || !e?.endDate || !e?.startDate
        ) checkError.push(true);

        return ({
          countMonth: e?.countMonth,
          incomeHead: e?.incomeHead?.id,
          unit: e?.incomeHead?.unit,
          discount: parseFloat(e?.discount || 0),
          endDate: moment(e?.endDate).format("YYYY-MM-DD"),
          startDate: moment(e?.startDate).format("YYYY-MM-DD"),
          additionalFeeTotal: e?.incomeHead?.price * e?.countMonth,
          total: e?.incomeHead?.price * e?.countMonth - e?.discount,
        })
      }
      )

      if (checkError.length > 0) {
        setValue(1);
        setRequired(true);
        return;
      }

      handleOpenPrint();

    },
  });

  const {
    errors,
    values,
    touched,
    resetForm,
    handleSubmit,
    getFieldProps,
    setFieldValue,
  } = formik;

  const hanldePrintAndSave = () => {

    const checkError = [];
    const additionalFeeData = listPaymentData?.map((e) => {

      if (!e?.countMonth || !e?.incomeHead?.id 
        // || !e?.endDate || !e?.startDate
      ) checkError.push(true);

      return ({
        countMonth: e?.countMonth,
        incomeHead: e?.incomeHead?.id,
        discount: parseFloat(e?.discount || 0),
        endDate: e?.endDate ? moment(e?.endDate).format("YYYY-MM-DD") : null,
        startDate: e?.startDate ? moment(e?.startDate).format("YYYY-MM-DD") : null,
        additionalFeeTotal: e?.incomeHead?.price * e?.countMonth,
        total: e?.incomeHead?.price * e?.countMonth - e?.discount,
      })
    }
    )

    if (checkError.length > 0) {
      setValue(1);
      setRequired(true);
      return;
    }

    setLoading(true);
    setRequired(false);

    const getPayAs = () => {
      if (values?.month) return "Month";
      if (values?.quarter) return "Quarter";
      if (values?.academicTermId) return "Term";
      return "Year";
    }

    // console.log("additionalFeeData::", additionalFeeData)

    createInvoiceForStudent({
      variables: {
        input: {
          
          paymentDate: `${moment(values?.paymentDate).format("YYYY-MM-DD")} ${moment().format("hh:mm:ss a")}`,

          discount: checkedAdditionalFee ? null : values?.discount || null,
          Amount: checkedAdditionalFee ? null : parseFloat(values?.Amount || 0),
          netAmount: checkedAdditionalFee ? null : parseFloat(values?.netAmount || 0),
          grossAmount: checkedAdditionalFee ? null : parseFloat(values?.grossAmount || 0),
          discountAmount: checkedAdditionalFee ? null : parseFloat(values?.discountAmount || 0),
          manualDiscount: checkedAdditionalFee ? null : parseFloat(values?.manualDiscount || 0),

          academicTermId: checkedAdditionalFee ? null : values?.academicTermId || null,
          endDate: checkedAdditionalFee ? null : moment(values?.endDate).format("YYYY-MM-DD"),
          startDate: checkedAdditionalFee ? null : moment(values?.startDate).format("YYYY-MM-DD"),
          month: checkedAdditionalFee ? null : values?.month ? moment(values?.month).format("MMMM") : "",

          billTo: values?.billTo || null,
          classId: values?.classId || null,
          additionalFee: additionalFeeData,
          schoolId: values?.schoolId || null,
          studentId: values?.studentId || null,
          enrollmentId: classVal?.enrollmentId || null,
          academicYearId: values?.academicYearId || null,
          exchangeRate: parseFloat(values?.exchangeRate),
          groupFeeType: checkedAdditionalFee ? null : getPayAs(),
        }
      }
    });
    handleClose();
  }

  useEffect(() => {
    setFieldValue("schoolId", selectedSchool?.id);
  }, [selectedSchool]);

  useEffect(() => {
    setFieldValue("academicYearId", academicYearVal?.id);
    setFieldValue("endDate", academicYearVal?.endDate);
    setFieldValue("startDate", academicYearVal?.startDate);

  }, [academicYearVal]);

  useEffect(() => {
    setFieldValue("studentId", selectedStudent?.id);
  }, [selectedStudent]);

  useEffect(() => {
    setFieldValue("programId", programmVal?.id);
  }, [programmVal]);

  useEffect(() => {
    setFieldValue("classId", classVal?.id);
  }, [classVal]);

  useEffect(() => {
    setFieldValue("billTo", selectedCustomer?.id);
  }, [selectedCustomer]);

  // useEffect(() => {
  //   // localStorage.setItem("sms-invoice-exchange-rate", values?.exchangeRate);
  //   if (values?.exchangeRate) {
  //     window.localStorage.setItem("sms-invoice-exchange-rate", JSON.stringify(values?.exchangeRate));
  //   }
  // }, [values?.exchangeRate]);

  useEffect(() => {
    localStorage.setItem("sms-invoice-created-at", values?.paymentDate);
  }, [values?.paymentDate]);

  useEffect(() => {
    if (open) {
      setValue(0);
      setListPaymentData([]);
      setCheckedAdditionalFee(false);
      setProgrammVal({ id: "", title: "" });
      setSelectedSchool({ id: "", title: "", });
      setSelectedCustomer({ id: "", title: "" });
      setSelectedStudent({ id: "", title: "", data: null });
      setAcademicYearVal({ id: "", title: "", endDate: null, startDate: null });
      setClassVal({ id: "", title: "", classId: "", enrollmentId: "", gradeId: "" });
      resetForm();
      setFieldValue("exchangeRate", lastExchangeRate);
      // setFieldValue("paymentDate", createdAtLocal !== undefined && createdAtLocal !== null && createdAtLocal !== "" ? createdAtLocal : moment());
      // setFieldValue("exchangeRate", exchangeRateLocal > 0 ? exchangeRateLocal : 4000);
    }
  }, [open]);

  const totalAmountAdditionalFee = listPaymentData?.map((e) => e?.incomeHead?.price * e?.countMonth - e?.discount)?.reduce((a, b) => a + b, 0);

  const additionalFee = listPaymentData?.map((e) => {
    return ({
      countMonth: e?.countMonth,
      incomeHead: e?.incomeHead?.title,
      unit: e?.incomeHead?.unit,
      discount: parseFloat(e?.discount || 0),
      endDate: moment(e?.endDate).format("YYYY-MM-DD"),
      startDate: moment(e?.startDate).format("YYYY-MM-DD"),
      additionalFeeTotal: e?.incomeHead?.price * e?.countMonth,
      total: e?.incomeHead?.price * e?.countMonth - e?.discount,
    })
  }
  )

  const getPayAs = () => {
    if (values?.month) return "Month";
    if (values?.quarter) return "Quarter";
    if (values?.academicTermId) return "Semester";
    return "Year";
  }

  const { data } = useQuery(GET_NEXT_INVOICE_ID,);
  // console.log("additionalFeeeee::", additionalFee);
  const invoiceData = {
    levels: classVal?.title,
    tel: selectedCustomer?.tel,
    additionalFee: checkedAdditionalFee ?
      additionalFee :
      values?.netAmount > 0 ?
        [{
          // countMonth: 1 + " " + getPayAs(),
          countMonth: 1,
          discount: 0,
          incomeHead: "ថ្លៃសិក្សា/Tuition Fee",
          unit: getPayAs(),
          endDate: moment(values?.endDate).format("YYYY-MM-DD"),
          startDate: moment(values?.startDate).format("YYYY-MM-DD"),
          total: values?.netAmount,
        },
        ...additionalFee] :
        additionalFee,
    shiftTime: classVal?.shiftName,
    billTo: selectedCustomer?.title,
    fullName: selectedStudent?.title,
    gender: selectedStudent?.data?.gender,
    dateOfBirth: moment(selectedStudent?.data?.dob).format("DD-MMM-YYYY"),
    latin: selectedStudent?.data?.englishName,
    khmerID: selectedStudent?.data?.student_id,
    paymentDate: moment(values?.paymentDate).format("DD-MMM-YYYY") + " " + moment().format("hh:mm a"),
    totalAmountUSD: checkedAdditionalFee ? parseFloat(totalAmountAdditionalFee || 0) : parseFloat((values?.netAmount || 0) + totalAmountAdditionalFee),
    no: moment(values?.paymentDate).format("YYYY") + (data?.getNextInvoiceId || 0)?.toString()?.padStart(6, '0'),
    totalAmountRiels:
      checkedAdditionalFee ?
        parseFloat(totalAmountAdditionalFee || 0) * parseFloat(values?.exchangeRate || 0)
        : parseFloat((values?.netAmount || 0) + totalAmountAdditionalFee) * parseFloat(values?.exchangeRate || 0),
  }
  // console.log("invoiceData::", invoiceData);
  if (openPrint) {
    return (
      <PrintInvoiceForCreate
        open={openPrint}
        data={invoiceData}
        handleClose={handleClose}
        handleClosePrint={handleClosePrint}
        hanldePrintAndSave={hanldePrintAndSave}
        handleUpdateServiceToPayNotification={handleUpdateServiceToPayNotification}
      />
    )
  }

  return (
    <Dialog open={open} className="dialog-container" maxWidth="md" fullWidth>
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              Create Receipt
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={6} md={4}>
                <Typography className="field-title">School</Typography>
                <SelectSchools selectedVal={selectedSchool} setSelectedVal={setSelectedSchool} />
                {!!errors.schoolId && touched.schoolId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.schoolId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={6} md={4}>
                <Typography className="field-title">Academic year</Typography>
                <SelectAcademicYear
                  selectedVal={academicYearVal}
                  setSelectedVal={setAcademicYearVal}
                />
                {!!errors.academicYearId && touched.academicYearId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.academicYearId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={6} md={4}>
                <Typography className="field-title">Student</Typography>
                <SelectStudentByAcademic
                  selectedVal={selectedStudent}
                  setSelectedVal={setSelectedStudent}
                  academicYearId={academicYearVal?.id}
                />
                {!!errors.studentId && touched.studentId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.studentId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={6} md={4}>
                <Typography className="field-title">Programme</Typography>
                <SelectProgramme
                  selectedVal={programmVal}
                  setSelectedVal={setProgrammVal}
                />
                {!!errors.programId && touched.programId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.programId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={6} md={4}>
                <Typography className="field-title">Class</Typography>
                <SelectStudentEnrollmentForInvoice
                  selectedVal={classVal}
                  setSelectedVal={setClassVal}
                  programId={programmVal?.id}
                  studentId={selectedStudent?.id}
                  academicYearId={academicYearVal?.id}
                />
                {!!errors.classId && touched.classId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.classId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={6} md={4}>
                <Typography className="field-title">Bill To</Typography>
                <SelectCustomerByStudent selectedVal={selectedCustomer} setSelectedVal={setSelectedCustomer} data={selectedStudent?.data} />
                {!!errors.billTo && touched.billTo && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.billTo}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={6} md={4}>
                <Typography className="field-title">Payment Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={values?.paymentDate}
                    inputFormat="dd-MM-yyyy"
                    onChange={(newValue) => setFieldValue("paymentDate", newValue)}
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
                {!!errors.paymentDate && touched.paymentDate && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.paymentDate}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={6} md={4}>
                <Typography className="field-title">Exchange rate</Typography>
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment sx={{ mr: 1, ml: -0.5, }}>
                        1$ :
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment sx={{ mr: 1, ml: -0.5, }}>
                        ៛
                      </InputAdornment>
                    ),
                    inputProps: { min: 0, },
                  }}
                  fullWidth
                  size="small"
                  type="number"
                  className="text-field"
                  {...getFieldProps("exchangeRate")}
                  helperText={touched.exchangeRate && errors.exchangeRate}
                  error={Boolean(touched.exchangeRate && errors.exchangeRate)}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <Stack direction="row" alignItems="center" justifyContent="center" height="100%" spacing={1} marginTop={1}>
                  <Typography className="field-title">Additional Fee Only</Typography>
                  <Checkbox checked={checkedAdditionalFee} onChange={({ target }) => {
                    if (listPaymentData.length === 0) setListPaymentData([paymentItem]);
                    setValue(1);
                    setCheckedAdditionalFee(target?.checked);
                  }
                  } />
                </Stack>
              </Grid>

              <Grid item xs={12} md={12}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ my: 1.5 }}>
                  <Typography className="field-title" sx={{ fontSize: 15 }}>Class : </Typography>
                  <Typography sx={{ fontSize: 15 }} >{classVal?.title}</Typography>
                </Stack>
              </Grid>

              <Grid item xs={12} md={12}>
                <Stack direction="column" spacing={1}>
                  <Typography className="field-title" sx={{ fontSize: 15 }}>Service to pay : </Typography>
                  <Stack direction="column" spacing={1} sx={{ paddingBottom: "20px" }}>
                    {
                      serviceToPayData?.map((row, index) => {
                        return (
                          <Stack direction="row" spacing={1} key={index}>
                            <Checkbox size="small"
                              sx={{ padding: '2px !important' }}
                              value={row?.status}
                              onChange={(e) => {
                                handleCheckServiceToPay(row?._id, e.target.checked)
                              }}
                            />
                            <Typography className="list-title-kh" sx={{ fontSize: 15 }}>{row?.incomeHeadName ? row?.incomeHeadName : `${row?.incomeType}(${row?.gradeName} ${row?.className})`} = {row?.verifiedAmount} $</Typography>
                          </Stack>
                        )
                      })
                    }
                  </Stack>
                </Stack>
              </Grid>
                  
              <Grid item xs={12} md={12} >
                <EnrollmentTabs
                  value={value}
                  formik={formik}
                  setValue={setValue}
                  required={required}
                  gradeId={classVal?.gradeId}
                  academicYearVal={academicYearVal}
                  listPaymentData={listPaymentData}
                  academicYearId={academicYearVal?.id}
                  setListPaymentData={setListPaymentData}
                  checkedAdditionalFee={checkedAdditionalFee}
                />
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>

      <DialogActions >
        <Stack direction="row" justifyContent="right" width="100%" sx={{ padding: "10px" }}>
          {loading ? (
            <Button className="btn-create" fullWidth>
              {t("loading")}
            </Button>
          ) : (
            <Button
              fullWidth
              className="btn-create"
              onClick={handleSubmit}
            >
              Preview
            </Button>
          )}
        </Stack>
      </DialogActions>
    </Dialog>

  );
}
